/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormDefinitionDto } from '../../models/form-definition-dto';

export interface FormDefinitionGet$Params {
  step?: number;
}

export function formDefinitionGet(
  http: HttpClient,
  rootUrl: string,
  params?: FormDefinitionGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<FormDefinitionDto>> {
  const rb = new RequestBuilder(rootUrl, formDefinitionGet.PATH, 'get');
  if (params) {
    rb.query('step', params.step, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormDefinitionDto>;
    }),
  );
}

formDefinitionGet.PATH = '/FormDefinition';
